import type { PlateLeafProps } from 'platejs/react'

import styles from './GeneratedContentLeaf.module.css'

import type { JSX } from 'react'

/**
 * Leaf wrapper that briefly flashes the background of freshly generated
 * content when it is inserted into the editor.
 */
function GeneratedContentLeaf({
  attributes,
  children,
}: PlateLeafProps): JSX.Element {
  return (
    <span {...attributes} className={styles.generatedContentLeaf}>
      {children}
    </span>
  )
}

export { GeneratedContentLeaf }
